import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

export default () => {
  const { state, commit } = useStore()
  const route = useRoute()

  function orderEvent (parsedData) {
    parsedData.payload.value.forEach((item, index) => {
      commit('updateEvent', {
        id: item,
        order: index
      })
    })
  }

  function updateEvent (parsedData) {
    const eventEntity = state.planner.allEvents.find(item => item.id === parsedData.payload.id)

    const data = {
      id: parsedData.payload.id,
      ...eventEntity,
      showAt: parsedData.payload.value.startDate || eventEntity?.showAt,
      event: {
        ...eventEntity.event,
        ...parsedData.payload.value
      }
    }

    if (parsedData.payload.value.bookId && parsedData.payload.value.bookId !== eventEntity.bookId) {
      const books = state.book.books

      if (books.some(b => b.id === parsedData.payload.value.bookId)) {
        data.bookId = parsedData.payload.value.bookId
      } else {
        commit('deleteEvent', parsedData.payload.id)
      }
    }

    commit('updateEvent', data)
  }

  function createEvent (parsedData) {
    const bookIds = route.query.spaces.split(',').map(i => parseInt(i))

    if (bookIds.includes(parseInt(parsedData.payload.bookId))) {
      commit('addEvent', parsedData.payload.value)
    }

    commit('addToAllEvents', parsedData.payload.value)
  }

  function deleteEvent (parsedData) {
    commit('deleteEvent', parsedData.payload.value)
  }

  return {
    orderEvent,
    updateEvent,
    createEvent,
    deleteEvent
  }
}
